/* import __COLOCATED_TEMPLATE__ from './plaid-link-manually.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
let PlaidLinkManually = (_class = class PlaidLinkManually extends Component {
  get useBlueCtaTreatment() {
    return !this.args.modalOptions?.isDisplayedInsideModalPartial && this.args.modalOptions?.blueCtaButtonBucket === 'treatment';
  }
  linkWithPlaid() {
    this.args.close(false);
  }
  confirm() {
    this.args.close(true);
  }
}, _applyDecoratedDescriptor(_class.prototype, "linkWithPlaid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "linkWithPlaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _class);
export { PlaidLinkManually as default };